export default class Provider {
    #url = '';

    constructor() {

    }

    static #getHeaders() {
        return {
            "Content-Type": "application/json"
        };
    }

    getUrl(path) {
        return `${this.#url}${path}`;
    }

    async get(path) {
        const response = await this.query(path);

        return await response.json();
    }

    async query(path, method, data) {
        const url = path !== undefined ? this.getUrl(path) : this.#url;
        const queryParams = {
            headers: Provider.#getHeaders()
        };

        if (method !== undefined) {
            queryParams.method = method;
        }

        if (data !== undefined) {
            queryParams.body = JSON.stringify(data);
        }

        try {
            return await fetch(url, queryParams);
        } catch (error) {
            throw "Server error. Try again later.";
        }
    }
}
